import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import UserFace from "../../images/user.png";
import EditIcon from "../../images/editpencil.svg";
import SettingIcon from "../../images/setting-grey.svg";
import BaseButton from "../UI/BaseButton/BaseButton";
import ReplayIcon from '@mui/icons-material/Replay';
import { Avatar, IconButton, Box, Typography } from "@mui/material";
import { ReceiptLong } from "@mui/icons-material";
import { RenderRoleBadges } from "../Navbar/UserProfile";
import { getCountryFlagUrl } from "../../util/utilfunctions/utilFunctions";
import { useSelector } from "react-redux";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";
import Eye from "../../images/eye.svg";
import LoansIcon from "../../images/loans.svg";

export default function DynamicTable({
    tableSource, //JSON file that will build the table
    tableData, // data from API call or config to fill the table
    handleEdit,
    handleSetting,
    handleLoans,
    handleButton,
    handleReverse,
    page,
    type,
    date,
    isAdmin,
    isAssociateAdmin,
    isLoanAdmin,
    isSuperAdmin,
    handleReceipt,
    handleReject,
    roles,
    userStatus
}) {
    let path = tableSource.sourcePath;

    const [rowsPerPage] = useState(parseInt(tableSource.rowsPerPage));
    const [lastVisitedRow, setLastVisitedRow] = useState(null); 
    let configVariables = useSelector((state) => state.config.baseConfig);
    let imageUrl = configVariables.imageURL;
    let authUser = localStorage.getItem('authUser');
        // console.log("tableData=================__",tableData);

    const handleRowClick = (rowId) => {
        setLastVisitedRow(rowId); // Update the last visited row ID
      };

      
    //TODO this must be set in such a manner that any data we have will return the total number of rows

    // const getCellData = (row, source, sourcePath) => {
    //     // console.log("getCellData=================__",sourcePath);
    //     const sanitizeText = (text) => {
    //         if (!text) return '';

    //         let decodedText = decodeHtmlEntities(text);
            
    //         // // Create a temporary DOM element to decode HTML entities
    //         // const tempElement = document.createElement("div");
    //         // tempElement.innerHTML = text;
    //         // let decodedText = tempElement.textContent || tempElement.innerText || "";
    
    //         // // Remove specific unwanted HTML entities while keeping other special characters
    //         // decodedText = decodedText
    //         //     .replace(/&(amp|lt|gt|quot|apos|#x?[0-9a-fA-F]+);/gi, "") // Remove HTML entities
    //         //     .replace(/\s+/g, " ") // Normalize spaces
    //         //     .trim();
            
    //         // console.log(decodedText)
    
    //         if ((isLoanAdmin === 'false' && isSuperAdmin === 'false') && /(loan|eloans)/i.test(decodedText)) {
    //             return '';
    //         }
    
    //         return decodedText;
    //     };
    
    //     if (isJSONParsable(source)) {
    //         source = JSON.parse(source);
    //     }


    //     if (Array.isArray(source)) {
    //         if(tableSource?.sourcePath == null) {
    //             return source
    //             .map((src) => sanitizeText(row?.[src] ?? ''))
    //             .join(" ");
    //         }
    //         //custom handler for new field in trans history table
    //         if (source[0] === "transactionbyfirstname" && row?.[tableSource?.sourcePath]?.[source[0]] === '') { 
    //             return sanitizeText(row?.[tableSource?.sourcePath]?.clerkname);
    //         }
    //         return source
    //             .map((src) => sanitizeText(row?.[tableSource?.sourcePath]?.[src] ?? ''))
    //             .join(" ");
    //     }
    
    //     if (Array.isArray(row)) {
    //         if (row.length === 0) {
    //             return;
    //         }
    //     }
        
    //     if(tableSource?.sourcePath == null) {
    //         return row ? sanitizeText(row?.[source]) : '';
    //     }
    //     return row ? sanitizeText(row?.[tableSource?.sourcePath]?.[source]) : '';
    // };
        const getCellData = (row, source, sourcePath) => {
    const sanitizeText = (text) => {
        if (!text) return '';

        let decodedText = decodeHtmlEntities(text);

        if ((isLoanAdmin === 'false' && isSuperAdmin === 'false') && /(loan|eloans)/i.test(decodedText)) {
            return '';
        }

        return decodedText;
    };

    if (isJSONParsable(source)) {
        source = JSON.parse(source);
    }

    if (Array.isArray(source)) {
        if (tableSource?.sourcePath == null) {
            return source
                .map((src) => sanitizeText(row?.[src] ?? ''))
                .join(" ");
        }

        // custom handler for new field in trans history table
        if (source[0] === "transactionbyfirstname" && row?.[tableSource?.sourcePath]?.[source[0]] === '') {
            return sanitizeText(row?.[tableSource?.sourcePath]?.clerkname);
        }

        //  Fix: inject otherNames (middle name) between firstName and lastName
        if (source.includes("firstName") && source.includes("lastName")) {
            const firstName  = sanitizeText(row?.[tableSource?.sourcePath]?.firstName  ?? '');
            const middleName = sanitizeText(row?.[tableSource?.sourcePath]?.otherNames ?? '');
            const lastName   = sanitizeText(row?.[tableSource?.sourcePath]?.lastName   ?? '');
            return [firstName, middleName, lastName].filter(Boolean).join(" ");
        }

        return source
            .map((src) => sanitizeText(row?.[tableSource?.sourcePath]?.[src] ?? ''))
            .join(" ");
    }

    if (Array.isArray(row)) {
        if (row.length === 0) {
            return;
        }
    }

    if (tableSource?.sourcePath == null) {
        return row ? sanitizeText(row?.[source]) : '';
    }
    return row ? sanitizeText(row?.[tableSource?.sourcePath]?.[source]) : '';
};

    const isJSONParsable = (testString) => {
        try {
            JSON.parse(testString);
            return true;
        } catch (err) {
            return false;
        }
    }

    // console.log("tableData================",tableData);

    return (
            <Table sx={{ minWidth: 800 }} aria-label="custom pagination table">
                <TableHead>
                    <TableRow>
                        {tableSource.columns.map((row, index) => (
                            <TableCell
                                align={tableSource.columns[index].headerAlignment}
                                className="customer-table-headers"
                                style={{ width: tableSource.columns[index].width }}
                            >
                                {tableSource.columns[index].header === "Action" && isAdmin !== 'true' ? null : <p className="transaction-table-headers">{tableSource.columns[index].header}</p>}
                                
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.isArray(tableData) && tableData.filter(row => row != null).length > 0 ? (tableData
                        .filter(row => row != null)
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => (
                            //add check here
                            <TableRow 
                                key={row[tableSource?.sourcePath]?.key}
                                onClick={() => {handleRowClick(row[tableSource?.sourcePath])}}
                                sx={{
                                    backgroundColor:
                                      row[tableSource?.sourcePath] === lastVisitedRow
                                        // ? "#dbefff" 
                                        ? "#f5f5f5"
                                        : "inherit",
                                  }}
                            >
                                {tableSource?.columns?.map((column) => {
                                    // console.log("column========",column);
                                    // console.log("row========",row);
                                    return (
                                        <TableCell
                                            style={{ width: column.width }}
                                        >
                                            {column.dataType === "pfp" &&
                                                <Avatar 
                                                    // src={
                                                    //     row?.Vuser?.photo === ""
                                                    //         ? UserFace
                                                    //         : imageUrl + row?.Vuser?.[column.source]
                                                    // }
                                                    src={UserFace}
                                                    className="table-customer-photo"
                                                    alt={row?.Vuser?.firstName}
                                                />
                                            }
                                            {column.dataType === "string" && getCellData(row, column?.source, column?.sourcePath)}
                                            {column.dataType === "country" && (
                                                <img 
                                                    src={getCountryFlagUrl(row[path][column.source])} 
                                                    alt={row[path][column.source]} 
                                                    width="30" 
                                                    height="20"
                                                    style={{ borderRadius: "3px" }}
                                                    onError={(e) => e.target.src = "path-to-default-flag.png"}
                                                    loading="lazy"
                                                />
                                            )}
                                            {/* {column.dataType === "country" &&
                                                <Flag
                                                    code={row[path][column.source]}
                                                    height="18"
                                                    fallback={<span>Unknown</span>}
                                                />} */}
                                            {column.dataType === "edit" &&
                                                (
                                                    <Box className="d-flex gap-3 justify-content-end align-items-center">
                                                        <IconButton
                                                            aria-label="edit"
                                                            onClick={() =>
                                                            handleEdit(row[tableSource?.sourcePath]?.id, row[tableSource?.sourcePath], "edit")
                                                            }
                                                        >
                                                            <img src={EditIcon} alt="Edit" className="edit-icon-crm" loading="lazy" />
                                                        </IconButton>

                                                        {/* {handleLoans && (
                                                            <IconButton
                                                                aria-label="open user loans"
                                                                title="Open User Loans"
                                                                onClick={() => handleLoans(row[path].id)}
                                                            >
                                                                <img src={LoansIcon} alt="Loans" className="edit-icon-crm" loading="lazy" />
                                                            </IconButton>
                                                        )} */}

                                                        {path !== "Vusersubacct" && (isSuperAdmin === "true" || (isAdmin === "true" && isAssociateAdmin === "false")  || isLoanAdmin === "true") &&
                                                            <img
                                                                src={SettingIcon}
                                                                onClick={() => handleSetting(row[path].id, row[path])}
                                                                alt="More Icon"
                                                                className="edit-icon-crm"
                                                                href="/#"
                                                                loading="lazy"
                                                            />
                                                        }
                                                    </Box>
                                                )}
                                                {column.dataType === "button" && (
                                                    <Box className="d-flex gap-3 justify-content-end align-items-center">
                                                        <BaseButton 
                                                            buttonText={"View Details"} 
                                                            onClick={() => handleButton(row[path].transtype, row[path].currcode)}>
                                                        </BaseButton>
                                                    </Box>
                                                )}

                                                {column.dataType === "moneygram-button" && (
                                                    <Box className="d-flex gap-3 justify-content-end align-items-center moneygram-btn-container">
                                                        <BaseButton
                                                            buttonStyle="button-style"
                                                            className="m-0"
                                                            buttonText={"Select User"} 
                                                            onClick={() => handleButton(row)}>
                                                        </BaseButton>
                                                    </Box>
                                                )}  

                                                {column.dataType === "approvebutton" && (
                                                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                                                        <Box className="d-flex gap-3 align-items-center">
                                                            <BaseButton 
                                                                buttonText={"Approve Card"} 
                                                                onClick={() => handleButton(row[path])}
                                                            />
                                                        </Box>

                                                        <Box className="d-flex gap-3 align-items-center">
                                                            <BaseButton 
                                                                buttonText={"Reject Card"} 
                                                                onClick={() => handleReject(row[path])}
                                                            />
                                                        </Box>
                                                    </Box>
                                                )}

                                                {column.header === "Name" && row?.Vuser?.firstName === "" && row?.Vuser?.lastName === "" && (
                                                    <Box className="">
                                                        {row?.Vuser?.otherNames}
                                                    </Box>
                                                )}

                                                {column.dataType === "modify" &&
                                                (
                                                    <Box className="d-flex gap-3 justify-content-end align-items-center">
                                                        <IconButton
                                                            aria-label="edit"
                                                            onClick={() =>
                                                                handleEdit(row[path])
                                                            }
                                                        >
                                                            <img src={EditIcon} alt="Edit" className="edit-icon-crm" loading="lazy" />
                                                        </IconButton>
                                                    </Box>
                                                )}
                                                {column.dataType === "reverse" && 
                                                (
                                                    <Box className="d-flex gap-3 justify-content-end align-items-center">

                                                    {(type !== "voucherHistory" && (row[path].transType === "82" || row[path].transType === "65" || row[path].transType === "141" || row[path].transType === "133" || row[path].transType === "132" ) &&
                                                    // {(type !== "voucherHistory" && (row[path].transType === "82" || row[path].transType === "65" || row[path].transType === "141" || row[path].transType === "133" ) &&
                                                        <IconButton 
                                                            aria-label="reverse" 
                                                            color="secondary"
                                                            onClick={() => handleReceipt(row[path].transID) }
                                                        >
                                                            <ReceiptLong />
                                                        </IconButton>
                                                    )}

                                                {((isSuperAdmin === 'true' || isAssociateAdmin === 'true') && 
                                                        <IconButton 
                                                        aria-label="reverse" 
                                                        color="secondary"
                                                        onClick={() => type == "voucherHistory" 
                                                        ? handleReverse(
                                                            row[path].txid,
                                                            parseInt(row[path].type),
                                                            parseInt(row[path].transferID),
                                                            "Voucher Cancellation"
                                                        )
                                                        : handleReverse(
                                                            row[path].referenceTXID, 
                                                            row[path].transType,
                                                            row[path].transID,
                                                            "Reversal",
                                                            row[path]
                                                        )
                                                        }
                                                    >
                                                        <ReplayIcon />
                                                    </IconButton>
                                                )}
                                                </Box>
                                            )}

                                            {
                                                column.dataType == "operatorStatus" && (
                                                    <Box className="d-flex gap-3 justify-content-start align-items-center">
                                                        <span
                                                            className={
                                                            row?.Vusersubacct?.status === "1"
                                                                ? "active-user"
                                                                : "disabled-user"
                                                            }
                                                        >
                                                            {userStatus
                                                            ? (userStatus.find(
                                                                (systemStatus) =>
                                                                    systemStatus?.userstatus?.statusID === row?.Vusersubacct?.status
                                                                ) || { userstatus: { name: "Status not found" } })?.userstatus?.name
                                                            : "Status not found"
                                                            }
                                                        </span>
                                                        {/* {row?.Vusersubacct?.status} */}
                                                    </Box>
                                                )
                                            }
                                            
                                            {
                                                column.dataType == "operatorRole" && (
                                                    <Box className="d-flex gap-3 justify-content-start align-items-center">
                                                        {<RenderRoleBadges userRoles={{roleid: row?.Vusersubacct?.roleid }} systemRoles={roles} />}
                                                    </Box>
                                                )
                                            }

                                                {column.dataType === "roles" && (
                                                    <Box className="d-flex gap-3 justify-content-start align-items-center">
                                                        {row["Securityuserrole"] ? <RenderRoleBadges userRoles={row["Securityuserrole"]} systemRoles={roles} /> : "No roles assigned"}
                                                    </Box>
                                                )}
                                                {column.dataType === "reportDate" && (
                                                    <Box className="d-flex gap-3 justify-content-start align-items-center">
                                                        {date}
                                                    </Box>
                                                )}

                                                {column.dataType === "view" && (
                                                    <Box className="d-flex gap-3 justify-content-start align-items-center">
                                                        <img src={Eye} alt="View" loading="lazy" className="pointer" onClick={() => handleButton(row)} />
                                                    </Box>
                                                )}
                                        </TableCell>)
                                }
                                )}
                            </TableRow>
                        )))
                        :
                        (
                            <TableRow>
                                <TableCell colSpan={tableSource.columns.length} align="center">
                                    <Box sx={{ padding: 2, fontStyle: "italic", color: "#000" }}>
                                    No records found
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
    );
}
